import { AppSession } from '../AppSession';
import { ChaveContratoEnum } from '../ChaveContratoEnum';
import { ContratoMenuModel } from './ContratoMenuModel';
import { RecomendacaoMenuModel } from './RecomendacaoMenuModel';
import { UsuarioModel } from './UsuarioModel';

export class DrawerMenuModel extends ContratoMenuModel {
    title: String
    icon: String
    page: String

    public static async getDrawerMenu(): Promise<Array<DrawerMenuModel>> {
        const menu = []

        // TODO: REFATORAR PARA PASSAR O TIPO DA AÇÃO (REDIRECT/POPUP)
        let item = null

        const user = await new DrawerMenuModel().obtemUsuarioLogado()

        item = new DrawerMenuModel()
        item.title = 'Recomendações'
        item.icon = '../assets/img/icon-sidebar-recomenda.svg'
        item.chaveContrato = [
            ChaveContratoEnum.CONTRATO_RECOMENDACAO_ACOES
        ]
        item.page = 'navigation/recomendacoes'
        item.active = true
        menu.push(item)

        item = new DrawerMenuModel()
        item.title = 'Carteiras recomendadas'
        item.icon = '../assets/img/icon-sidebar-carteira-recomendada.svg'
        item.nivelRestricao = ContratoMenuModel.NIVEL_RESTRICAO_BAIXO
        item.page = 'navigation/carteira-recomendada'
        item.active = true
        menu.push(item)


        item = new DrawerMenuModel()
        item.title = 'Opções'
        item.icon = '../assets/img/icon-opcoes.svg'
        item.chaveContrato = [
            ChaveContratoEnum.CONTRATO_RECOMENDACAO_OPCOES_BRASIL
        ]
        item.page = 'navigation/recomendacoes-opcoes/' + RecomendacaoMenuModel.TIPO_ACOES_BOLSA
        item.active = true
        menu.push(item)


        item = new DrawerMenuModel()
        item.title = 'Prisma PhiCube'
        item.icon = '../assets/img/icon-sidebar-prisma.svg'
        item.chaveContrato = [
            ChaveContratoEnum.CONTRATO_PRISMA_ACOES,
            ChaveContratoEnum.CONTRATO_PRISMA_CRIPTOMOEDAS,
            ChaveContratoEnum.CONTRATO_PRISMA_EUA,
            ChaveContratoEnum.CONTRATO_PRISMA_FUNDOS_IMOBILIARIOS,
            ChaveContratoEnum.CONTRATO_PRISMA_FUNDOS_INDICES,
            ChaveContratoEnum.CONTRATO_PRISMA_INDICES
        ]
        item.page = 'navigation/prisma'
        item.active = true
        menu.push(item)

        item = new DrawerMenuModel()
        item.title = 'Análise de ativos'
        item.icon = '../assets/img/icon-sidebar-analise.svg'
        item.chaveContrato = [
            ChaveContratoEnum.CONTRATO_ANALISE_ACOES,
            ChaveContratoEnum.CONTRATO_ANALISE_CRIPTOMOEDAS,
            ChaveContratoEnum.CONTRATO_ANALISE_EUA,
            ChaveContratoEnum.CONTRATO_ANALISE_FUNDOS_IMOBILIARIOS,
            ChaveContratoEnum.CONTRATO_ANALISE_FUNDOS_INDICES,
            ChaveContratoEnum.CONTRATO_ANALISE_INDICES
        ]
        item.page = 'navigation/analise-ativos'
        item.active = true
        menu.push(item)

        item = new DrawerMenuModel()
        item.title = 'Notícias'
        item.icon = '../assets/img/news.svg'
        item.page = 'navigation/home/noticias'
        item.active = true
        item.nivelRestricao = ContratoMenuModel.NIVEL_RESTRICAO_BAIXO
        menu.push(item)

        if (user.aai) {
            item = new DrawerMenuModel()
            item.title = 'Prospecção de Cliente'
            item.icon = '../assets/img/icon-sidebar-user.svg'
            item.chaveContrato = []
            item.page = 'client-prospect'
            item.active = true
            item.nivelRestricao = ContratoMenuModel.NIVEL_RESTRICAO_BAIXO
            menu.push(item)
        }

        item = new DrawerMenuModel()
        item.title = 'Pesquisa do investidor'
        item.icon = '../assets/img/icon-sidebar-form.svg'
        item.page = 'formulario-trader'
        item.active = true
        item.nivelRestricao = ContratoMenuModel.NIVEL_RESTRICAO_BAIXO
        menu.push(item)

        item = new DrawerMenuModel()
        item.title = 'Configurações'
        item.icon = '../assets/img/icon-sidebar-config.svg'
        item.page = 'navigation/configuracoes'
        item.active = true
        item.nivelRestricao = ContratoMenuModel.NIVEL_RESTRICAO_BAIXO
        menu.push(item)

        // item = new DrawerMenuModel()
        // item.title = 'Blog & artigos'
        // item.icon = '../assets/img/icon-sidebar-blog.svg'
        // item.page = 'navigation/home/blog'
        // item.active = true
        // item.nivelRestricao = ContratoMenuModel.NIVEL_RESTRICAO_BAIXO
        // menu.push(item)

        item = new DrawerMenuModel()
        item.title = 'Indicar o app'
        item.icon = '../assets/img/icon-sidebar-compartilha.svg'
        item.chaveContrato = [ChaveContratoEnum.CONTRATO_INDICAR_APP]
        item.page = ''
        item.active = true
        item.nivelRestricao = ContratoMenuModel.NIVEL_RESTRICAO_BAIXO
        menu.push(item)

        item = new DrawerMenuModel()
        item.title = 'Avaliar o app'
        item.icon = '../assets/img/icon-sidebar-like.svg'
        item.page = 'avaliacao'
        item.active = true
        item.nivelRestricao = ContratoMenuModel.NIVEL_RESTRICAO_BAIXO
        menu.push(item)
        
        return menu;
    }

    async obtemUsuarioLogado(): Promise<UsuarioModel> {
        return await AppSession.getUser()
    }
}